import React, { useState, useEffect } from 'react';
import InputSimple from '../../components/InputSimple';
import { PostAsync, Inputs } from '../../helpers/Functions';
import StateContext from '../../helpers/ContextState';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Comentarios from '../comentarios';
import BotonVolverHome from '../../components/BotonVolverHome';
import '../../components/HistorialTable.css';

const unidades = [
  { value: 'dias', label: 'Días' },
  { value: 'semanas', label: 'Semanas' },
  { value: 'meses', label: 'Meses' },
];

const App = () => {
  const context = React.useContext(StateContext);
  const [inputs, setInputs] = useState({});
  const [unidad, setUnidad] = useState('dias');
  const [historial, setHistorial] = useState([]);
  const [reset, setReset] = useState(false);

  useEffect(() => {
    if (reset) setReset(false);
  }, [reset]);

  useEffect(() => {
    let mounted = true;
    getInit(mounted);
    return () => { mounted = false; };
  }, []);

  const getInit = (mounted) => {
    PostAsync('Configuracion', 'GetVigenciaPrecios', {}, { ...context }).then((response) => {
      if (response.data !== undefined && mounted) {
        const d = response.data || {};
        d.observacion = '';
        setInputs(d);
        if (d.unidad) {
          setUnidad(d.unidad);
        }
      }
    });
    PostAsync('Configuracion', 'GetHistorialVigenciaPrecios', {}, { ...context }).then((response) => {
      if (response.historial !== undefined && mounted) {
        setHistorial(response.historial);
      }
    });
  };

  const onChange = (e) => Inputs(e, inputs, setInputs);

  const onSubmit = (e) => {
    e.preventDefault();
    PostAsync('Configuracion', 'SetVigenciaPrecios', { ...inputs, unidad: unidad }, { ...context }).then(() => {
      setReset(true);
      getInit(true);
    });
  };

  return (
    <>
      <div className="h5 mb-3">Vigencia de precios exclusivos para asociados</div>
      <Row className="mb-4">
        <form onSubmit={onSubmit}>
          <Row className="mb-4">
            <Col xs="12" md="2">
              <InputSimple
                className="form-control"
                type="number"
                name="cantidad"
                required={true}
                defaultValue={inputs.cantidad}
                placeholder="Cantidad"
                onChange={onChange}
              />
            </Col>
            <Col xs="12" md="3">
              <Row>
                {unidades.map((u, key) => (
                  <Col key={key} xs="4" className="mb-2">
                    <div className="d-grid gap-2">
                      <Button
                        variant={unidad === u.value ? 'primary' : 'secondary'}
                        size="sm"
                        type="button"
                        onClick={() => setUnidad(u.value)}
                      >
                        {u.label}
                      </Button>
                    </div>
                  </Col>
                ))}
              </Row>
              <div className="form-control-label">Unidad de vigencia</div>
            </Col>
            <Col xs="12" md="4">
              <InputSimple
                className="form-control"
                type="text"
                name="observacion"
                defaultValue={inputs.observacion}
                placeholder="Observación"
                onChange={onChange}
              />
            </Col>
            <Col xs="12" md="1">
              <BotonVolverHome />
            </Col>
            <Col xs="12" md="2">
              <Button type="submit">Actualizar</Button>
            </Col>
          </Row>
        </form>
      </Row>

      <div className="row">
        <div className="col h5 mt-3">Historial cambios Vigencia de Precios</div>
      </div>
      <div className="row">
        <div className="col">
          <Table responsive>
            <thead>
              <tr>
                <th className="text-center">#</th>
                <th className="text-center">Cantidad</th>
                <th className="text-center">Unidad</th>
                <th className="text-center">Observación</th>
                <th className="text-center">Funcionario</th>
                <th className="text-center">Fecha</th>
                <th className="text-center">Hora</th>
              </tr>
            </thead>
            <tbody>
              {historial && historial.length > 0 ? (
                historial.map((row, key) => (
                  <tr key={key}>
                    <td className="text-center">{key + 1}</td>
                    <td className="text-center">{row.cantidad}</td>
                    <td className="text-center">{row.unidad}</td>
                    <td className="text-center">{row.observacion || 'Sin Observación'}</td>
                    <td className="text-center">{row.funcionario || 'Desconocido'}</td>
                    <td className="text-center">{row.fecha}</td>
                    <td className="text-center">{row.hora}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No hay registros en el historial.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      <Row>
        <Col xs="12">
          {!reset ? <Comentarios id={"VigenciaPrecios"} /> : false}
        </Col>
      </Row>
    </>
  );
};

export default App;
